module.exports = __webpack_public_path__ + "static/media/selectedDropdownValue.24da008f.svg";